import "@babel/polyfill";
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  updateLeftMenuSidebarVisible
} from './reducers/leftMenuSidebarReducer';
import {Router, Route} from 'react-router-dom';
import history from './history';
import {Icon, Menu, Segment, Sidebar } from 'semantic-ui-react'
import TopMenuBar from './components/TopMenuBar/TopMenuBar';
import BottomMenuBar from './components/BottomMenuBar/BottomMenuBar';
import {TermsConditions} from './components/TermsConditions/TermsConditions';
import {PrivacyPolicy} from './components/PrivacyPolicy/PrivacyPolicy';
import {ContactUs} from './components/ContactUs/ContactUs';
import HomePage from './components/HomePage/HomePage';
import LaptopQuizPage from './components/LaptopQuizPage/LaptopQuizPage';
import SearchPage from './components/SearchPage/SearchPage';
import './App.css';

class App extends Component {
  linkpath;
  constructor(props) {
    super(props);
    this.handleSidebarHide = this.handleSidebarHide.bind(this);
    window.mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
  }

  handleSidebarHide(event, data) {
    if (!this.props.leftMenuSidebarVisible) {
      // handles corner case
      return;
    } else {
      this.props.updateLeftMenuSidebarVisible(false);
      if (data) {
        // user clicked on link instead of clicking on outside
        history.push(data.linkpath);
      }
    }
  }

  render() {
    return (
      <div className="App Regular-page">
        {/*<header className="App-header">*/}
          {/*<img src={logo} className="App-logo" alt="logo" />*/}
          {/*<h1 className="App-title">Welcome to Permutize</h1>*/}
        {/*</header>*/}
        <Router history={history}>
          <div>
            <Sidebar.Pushable as={Segment}>
              <Sidebar
                as={Menu}
                animation='overlay'
                icon='labeled'
                inverted
                vertical
                visible={this.props.leftMenuSidebarVisible}
                width='thin'
              >
                <Menu.Item as="a" linkpath="/" onClick={this.handleSidebarHide}>
                  <Icon name="home" /> Home
                </Menu.Item>
                <Menu.Item as="a" linkpath="/laptopquiz" onClick={this.handleSidebarHide}>
                  <Icon name="laptop" /> Laptop Genie
                </Menu.Item>
                <Menu.Item as="a" linkpath="/terms" onClick={this.handleSidebarHide}>
                  <Icon name="shield"/> Terms and Conditons
                </Menu.Item>
                <Menu.Item as="a" linkpath="/privacy" onClick={this.handleSidebarHide}>
                  <Icon name="attention"/> Privacy Policy
                </Menu.Item>
                <Menu.Item as="a" linkpath="/contact" onClick={this.handleSidebarHide}>
                  <Icon name="info"/> Contact
                </Menu.Item>
              </Sidebar>
              <Sidebar.Pusher dimmed={this.props.leftMenuSidebarVisible} onClick={this.handleSidebarHide}>
                <div>
                  <TopMenuBar/>
                  <Route path="/" exact={true} component={HomePage} />
                  <Route path="/laptopquiz" component={LaptopQuizPage} />
                  <Route path="/search" component={SearchPage}/>
                  <Route path="/terms" component={TermsConditions}/>
                  <Route path="/privacy" component={PrivacyPolicy}/>
                  <Route path="/contact" component={ContactUs}/>
                  <BottomMenuBar/>
                </div>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </div>
        </Router>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    leftMenuSidebarVisible: state.leftMenuSidebar.leftMenuSidebarVisible
  }),
  {
    updateLeftMenuSidebarVisible
  }
)(App);



// WEBPACK FOOTER //
// ./src/App.js